import React  from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import BoxDesign from './BoxDesign';
import { DictioneryPanel } from '../../Data/DictioneryPanel';
import { IconRouting } from '../../Assets/panels/IconRouting';
import { LoadingColor } from '../LoadingColor';
import { IconTimer } from '../../Assets/panels/IconTimer';
import { IconHotels } from '../../Assets/panels/IconHotels';
import { IconResurant } from '../../Assets/panels/IconResurant';
import { IconAirplane } from '../../Assets/panels/IconAirplane';
import { IconBus } from '../../Assets/panels/IconBus';
import { IconShip } from '../../Assets/panels/IconShip';
import { CountriesShowByCode } from '../Inputs/CountriesShowByCode';
import { CitiesShowByCode } from '../Inputs/CitiesShowByCode';
import { data as dataClass } from '../Inputs/ClassTypeV2Selector';
import { DateObject } from 'react-multi-date-picker';

const Styles = styled.div`
    width: 100%;
    .over-route {
        margin: 0rem 1rem 1rem;
        padding: 1.25rem;
        position: relative;
        display: flex;
        flex-direction: column;
        gap: 1.5rem;
        .title-part {
            color: var(--text-h);
            display: flex;
            align-items: center;
            gap: 1rem;
            &.active {
                color: var(--main-color);
                .icon {
                    fill: var(--main-color);
                }
            }
            &.inside {
                color: #000000;
                .icon {
                    fill: var(--n-grey-2);
                }
            }
            .icon {
                fill: var(--text-h);
                width: 48px;
                height: 48px;
                display: block;
            }
            .text {
                font-weight: 700;
                font-size: 1.25rem;
            }
        }
        .line {
            height: 1px;
            background-color: var(--n-grey-1);
        }
        .box-routing {
            border-radius: var(--border-radius-3);
            background-color: var(--n-grey-01);
            padding: 1.5rem 2rem;
            display: flex;
            gap: 3rem;
            align-items: center;
            /* justify-content: space-between; */
            .line-h {
                align-self: normal;
                width: 2px;
                background-color: var(--n-grey-11);
                color: #FFFFFF00;
            }
            .data {
                display: flex;
                flex-direction: column;
                gap: 0.5rem;
                .title {
                    font-size: 0.75rem;
                    font-weight: 500;
                    color: var(--n-grey-2);
                }
                .value {
                    font-size: 1.25rem;
                    font-weight: 500;
                }
            }
        }
    }
    @media screen and (max-width: 850px) {
        .over-route {
            .box-routing {
                display: grid;
                grid-template-columns: repeat(3, 1fr);
                gap: 0.5rem;
                row-gap: 1rem;
                align-items: center;
                justify-items: center;
                .data {
                    justify-self: start;
                }
            }
        }
    }
`




export default function TourDetailsFacilityCartV2 ({loading = true, data, lang}){
    if(loading){
        return (
            <Styles>
                <LoadingColor/>
            </Styles>
        )
    }
    const makeTicket = (ticket, i) => {
        let isMobile = (window.innerWidth < 850) ? true : false;
        let toppart = "";
        switch(ticket.Transport_Type_Id) {
            case 1:
                toppart = (
                    <div className="title-part inside" key={i + "a"}>
                        <IconAirplane className={"icon"}/>
                        <div className='text'>
                            {lang === "fa" ? ticket.Transport_Type_Name : ticket.Transport_Type_EnName}
                        </div>
                    </div>
                )
                break;
            case 2:
                toppart = (
                    <div className="title-part inside" key={i + "a"}>
                        <IconBus className={"icon"}/>
                        <div className='text'>
                            {lang === "fa" ? ticket.Transport_Type_Name : ticket.Transport_Type_EnName}
                        </div>
                    </div>
                )
                break;
            case 3:
                toppart = (
                    <div className="title-part inside" key={i + "a"}>
                        <IconBus className={"icon"}/>
                        <div className='text'>
                            {lang === "fa" ? ticket.Transport_Type_Name : ticket.Transport_Type_EnName}
                        </div>
                    </div>
                )
                break;
            case 4:
                toppart = (
                    <div className="title-part inside" key={i + "a"}>
                        <IconShip className={"icon"}/>
                        <div className='text'>
                            {lang === "fa" ? ticket.Transport_Type_Name : ticket.Transport_Type_EnName}
                        </div>
                    </div>
                )
                break;
            default:
                toppart = (
                    <div className="title-part inside" key={i + "a"}>
                        <IconTimer className={"icon"}/>
                        <div className='text'>
                            {lang === "fa" ? ticket.Transport_Type_Name : ticket.Transport_Type_EnName}
                        </div>
                    </div>
                )
                break;
        }
        let findClass = dataClass.find((v) => v.Class_Type_Id === ticket.Tour_Ticket_Class);
        let time = new DateObject();
        time.setFormat("HH:mm:ss");
        time.parse(ticket.Tour_Ticket_Duration_Time);
        time = time.format("HH:mm")
        return (
            <>
                {toppart}
                <div className='box-routing' key={i + "b"}>
                    <div className='data'>
                        <div className='title'>
                            {DictioneryPanel.packagesDict.ticketTransportProvider[lang]}
                        </div>
                        <div className='value'>
                            {lang === "fa" ? ticket.Transport_Provider_Name : ticket.Transport_Provider_EnName}
                        </div>
                    </div>
                    <div className='line-h'></div>
                    <div className='data'>
                        <div className='title'>
                            {DictioneryPanel.packagesDict.ticketBoardingArea[lang]}
                        </div>
                        <div className='value'>
                            {lang === "fa" ? ticket.Boarding_Area_From_Name : ticket.Boarding_Area_From_EnName}
                        </div>
                    </div>
                    {
                        (!isMobile) ? (
                            <div className='line-h'>-</div>
                        ) : ""
                    }
                    <div className='data'>
                        <div className='title'>
                            {DictioneryPanel.packagesDict.ticketDropofArea[lang]}
                        </div>
                        <div className='value'>
                            {lang === "fa" ? ticket.Boarding_Area_To_Name : ticket.Boarding_Area_To_EnName}
                        </div>
                    </div>
                    <div className='line-h'></div>
                    <div className='data'>
                        <div className='title'>
                            {DictioneryPanel.packagesDict.ticketClass[lang]}
                        </div>
                        <div className='value'>
                            {lang === "fa" ? findClass.Class_Type_Name : findClass.Class_Type_EnName}
                        </div>
                    </div>
                    {
                        (!isMobile) ? (
                            <div className='line-h'>-</div>
                        ) : ""
                    }
                    <div className='data'>
                        <div className='title'>
                            {DictioneryPanel.packagesDict.ticketDurationTime[lang]}
                        </div>
                        <div className='value'>
                            {time}
                        </div>
                    </div>
                    <div className='line-h'></div>
                    <div className='data'>
                        <div className='title'>
                            {DictioneryPanel.packagesDict.tourCargo[lang]}
                        </div>
                        <div className='value'>
                            {ticket.Tour_Ticket_Baggage_Allowance}
                        </div>
                    </div>
                </div>
                <div className='line' key={i + "c"}></div>
            </>
        );
    }
    const makeRoutes = (routes, starting = {}) => {
        let htmlOutput = [];
        if(Object.keys(starting).length > 0 && starting.tickets.length > 0){
            htmlOutput.push(makeTicket(starting.tickets[0], 0));
        }
        for (let i = 1; i < routes.length; i++) {
            const element = routes[i];
            htmlOutput.push(
                <div className="title-part active">
                    <IconRouting className={"icon"}/>
                    <div className='text'>
                        {
                           (lang === "fa" ? element.City_Name : element.City_EnName)
                        }
                    </div>
                </div>
            )
            if(Object.keys(element).length > 0 && element.tickets.length > 0){
                htmlOutput.push(makeTicket(element.tickets[0], i));
            }
        }
        return htmlOutput;
    }
    let routes = data.ROUTES ? data.ROUTES : [];
    // console.log(routes);
    let starting = {};
    if(routes.length){
        starting = routes[0];
    }
    return (
        <Styles>
            <BoxDesign className='over-route'>
                <div className="title-part active">
                    <IconRouting className={"icon"}/>
                    <div className='text'>
                        {DictioneryPanel.packagesDict.startTour[lang]} {
                            "(" + (lang === "fa" ? starting.City_Name : starting.City_EnName) + ")"
                        }
                    </div>
                </div>
                {makeRoutes(routes, starting)}
                <div className="title-part">
                    <IconRouting className={"icon"}/>
                    <div className='text'>
                        {DictioneryPanel.packagesDict.endTour[lang]} {
                            "(" + (lang === "fa" ? starting.City_Name : starting.City_EnName) + ")"
                        }
                    </div>
                </div>
            </BoxDesign>
        </Styles>
    )
}